import { createFileRoute } from '@tanstack/react-router';
import { GroupingRuleSetTypes } from '@views/Settings/GroupingRules/types';
import { PAGE_PATHS } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/')({
  staticData: {
    groupingRuleType: GroupingRuleSetTypes.Ticket,
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({
      app: PAGE_PATHS.RULE_SET,
      path: PAGE_PATHS.RULE_SET,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
